<aside class="sidebar animate-fade-in">

  <!-- Logo -->
  <div class="sidebar-logo">
    <div class="logo-icon">
      <span class="material-symbols-outlined">architecture</span>
    </div>
    <div class="logo-text">
      <h1>Scheduler</h1>
      <span class="text-muted">Fluid Architect</span>
    </div>
  </div>

  <!-- Nav links -->
  <nav class="sidebar-nav">
    <a class="nav-item" routerLink="/dashboard" routerLinkActive="nav-item--active">
      <span class="material-symbols-outlined">dashboard</span>
      <span>Inicio</span>
    </a>
    <a class="nav-item" routerLink="/booking" routerLinkActive="nav-item--active">
      <span class="material-symbols-outlined">calendar_today</span>
      <span>Reservas</span>
    </a>
    <a class="nav-item nav-item--disabled" href="#">
      <span class="material-symbols-outlined">group</span>
      <span>Clientes</span>
    </a>
  </nav>

  <!-- PRO upgrade block -->
  <div class="sidebar-footer">
    <div class="pro-callout">
      <div class="pro-callout__header">
        <span class="material-symbols-outlined" style="font-variation-settings:'FILL' 1;">workspace_premium</span>
        <span>Desbloquear Premium</span>
      </div>
      <p>Pagos, branding y más</p>
      <a routerLink="/settings" class="btn-pro" style="width:100%; font-size:0.8rem; padding: 10px 16px;">
        <span class="material-symbols-outlined" style="font-size:1rem; font-variation-settings:'FILL' 1;">workspace_premium</span>
        Ir a PRO
      </a>
    </div>

    <a class="nav-item" routerLink="/settings" routerLinkActive="nav-item--active">
      <span class="material-symbols-outlined">tune</span>
      <span>Config. PRO</span>
    </a>
  </div>

</aside>
